'use client'

import React, { FC, ReactElement } from 'react'
import styles from './HeaderLink.module.css'
import Link from '@/components/link'
import classNames from 'classnames'
import { usePathname } from 'next/navigation'
import MenuList from '@/components/menu-list'
import { useRouter } from 'next/navigation'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const HeaderLink: FC<{
	name: string
	href?: string
	className?: string
	featured?: boolean
	dropdown?: any
	onClick?: () => void
}> = (props): ReactElement => {
	const pathname = usePathname()
	const selected = (pathname || '') === props?.href
	const router = useRouter()

	if (props?.dropdown) {
		const options = props?.dropdown?.map((e: any) => ({
			...e,
			onClick: () => {
				router.push(e.href)
				props?.onClick && props.onClick()
			}
		}))

		return (
			<MenuList
				className={props.className}
				selected={selected}
				name={props.name}
				options={options}
			/>
		)
	}

	if (!props.href) {
		return (
			<div
				onClick={props.onClick}
				className={classNames(styles.root, 'regular', {
					[styles.selected]: selected,
					[props.className as any]: !!props.className,
					[styles.featured]: props.featured,
					[styles.featuredSelected]: props.featured && selected
				})}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick(props.onClick)}
			>
				{props.name}
			</div>
		)
	}

	return (
		<Link href={props.href} onClick={props.onClick}>
			<div
				className={classNames(styles.root, 'regular', {
					[styles.selected]: selected,
					[props.className as any]: !!props.className,
					[styles.featured]: props.featured,
					[styles.featuredSelected]: props.featured && selected
				})}
			>
				{props.name}
			</div>
		</Link>
	)
}

export default HeaderLink
